module.exports = __webpack_public_path__ + "static/media/BotTeam.2982f910.jpeg";